/*
 * @Author: ylq
 * @Date: 2021-08-24 16:58:33
 * @Desc: 工具箱
 * @Last Modified by: ylq
 * @Last Modified time: 2024-03-27 10:33:01
 */
class Tools {
  constructor() {}
  // 设置cookie
  setCookie(name, value, t, domain) {
    var days = (t === undefined ? 1 : t) * 24 * 60 * 60 * 1000;
    var hostname = window.location.hostname;
    var d = domain || hostname;
    var exp = new Date();
    exp.setTime(exp.getTime() + days);
    console.log(15, exp.toGMTString());
    document.cookie = `${name}=${escape(value)};path=/;domain=${d};expires=${exp.toGMTString()}`;
  }
  // 获取cookie
  getCookie(key) {
    var strCookie = document.cookie;
    var arrCookie = strCookie.split(';');
    for (var m = 0; m < arrCookie.length; m++) {
      var ac = arrCookie[m].replace(/\s*/g, '');
      if (ac.indexOf(key + '=') != -1) {
        return ac.replace(key + '=', '');
      }
    }
  }
  // 生成随机6位字符串
  randomString(len) {
    len = len || 6;
    var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var maxPos = chars.length;
    var pwd = '';
    for (let i = 0; i < len; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  }

  // 数组生成树
  arrayToTree(arr = [], pid = 0, props = { children: 'children', id: 'id', pid: 'pid' }) {
    const p = props;
    const list = [];
    const obj = {};
    arr.forEach((el) => {
      obj[el[p.id]] = el;
      if (el[p.pid] === pid) {
        list.push({ ...el, children: this.arrayToTree(arr, el[p.id]).tree });
      }
    });
    return { obj, tree: list };
  }

  // 检测文件是否时🈯️定后缀
  checkFileExt(url, type) {
    const typeObj = {
      img: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'ico', 'svg'],
      video: ['mp4', 'm2v', 'mkv', 'avi'],
      pdf: ['pdf'],
      xlsx: ['xls', 'xlsx'],
      zip: ['zip', 'rar'],
      docs: ['doc', 'docx'],
      unableImg: ['tiff', 'ai', 'cdr', 'eps'] //img无法加载的图片类型
    };
    if (url) {
      const n = url.lastIndexOf('.');
      const ext = url.substring(n + 1).toLowerCase();
      return typeObj[type]?.includes(ext);
    }
    return false;
  }

  // 根据传入的2个时间，计算间隔天数，计算每个日期数量，计算环比日期
  //  st 开始时间，et,结束时间，hasOqo 是否有环比日期 hasToday是否包含今天
  getDateTotal(st, et, hasOqo = false, hasToday) {
    console.log(6900001111, st, et, hasOqo, hasToday);
    const defst = st ? new Date(st) : new Date();
    const defet = et ? new Date(et) : new Date();
    console.log(690000, defst, defet);
    const oneDay = 24 * 60 * 60 * 1000;
    let start = defst;
    let end = defet;
    if (defst.getTime() > defet.getTime()) {
      start = defet;
      end = defst;
    }
    console.log(690001, start, end);
    // 获取毫秒
    const times = end.getTime() - start.getTime();
    // 获取天数
    const dayNum = parseInt(times / oneDay);
    // 获取年月日
    const getYmd = (ymd) => {
      const date = new Date(ymd);
      const gm = date.getMonth() + 1;
      const m = gm < 10 ? `0${gm}` : gm;
      const d = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
      return `${date.getFullYear()}-${m}-${d}`;
    };
    // 获取区间
    const getAreaDate = (n, s) => {
      const arr = [];
      const arrDate = [];
      const arrWeek = [];
      const date = [];
      for (let index = 0; index < n; index++) {
        let t = s.getTime() + index * oneDay;
        if (hasToday === false) {
          t = s.getTime() + index * oneDay - oneDay;
        }
        arr.push(t);
        arrDate.push(getYmd(t));
        arrWeek.push(new Date(t).getDay());
        if (index === 0) {
          date.push(getYmd(t));
        }
        if (index === n - 1) {
          console.log(6900023101, index, n - 1, getYmd(t));
          date.push(getYmd(t));
        }
      }
      return { arr, arrDate, arrWeek, date };
    };
    // 如果需要环比日期
    console.log(hasOqo);
    let oqoArea = {};
    if (hasOqo) {
      const oqoDayNum = dayNum + 1;
      const oqoStart = start.getTime() - oqoDayNum * oneDay;
      // const oqoEnd = start.getTime() - oneDay ;
      console.log(6900023, oqoStart);
      oqoArea = getAreaDate(oqoDayNum, new Date(oqoStart));
      // oqoArea.date = [getYmd(oqoStart),getYmd(oqoEnd)]
    }
    // 获取所有的数据 天数，周，日期秒，日期
    const area = getAreaDate(dayNum + 1, start);
    const o = {
      num: dayNum,
      week: area.arrWeek,
      date: area.date,
      dateArea: area.arrDate,
      dateAreaMs: area.arr,
      oqoArea: oqoArea.arrDate,
      oqoAreaMs: oqoArea.arr,
      oqoDate: oqoArea.date,
      oqoAreaWeek: oqoArea.arrWeek
    };
    // 如果只传了1天时间
    if (start.getTime() === end.getTime()) {
      const d = [getYmd(start), getYmd(end)];
      o.num = 0;
      o.week = start.getDay();
      o.date = d;
      o.dateArea = d;
      o.dateAreaMs = [start.getTime(), start.getTime()];
      if (hasOqo) {
        const yesterday = start.getTime() - oneDay;
        o.oqoArea = [getYmd(yesterday), getYmd(yesterday)];
        o.oqoAreaMs = [yesterday, yesterday];
        o.oqoDate = [getYmd(yesterday), getYmd(yesterday)];
        o.oqoAreaWeek = new Date(yesterday).getDay();
      }
    }
    return o;
  }
  // 清除区号+86
  clearCountryNum(num) {
    if (!num) return;
    let n = num;
    if (num.indexOf('+86') === 0) {
      n = num.replace('+86', '');
      n = n.trim();
    }
    return n;
  }
  // 下载方法
  downLoad(res, name) {
    // 获取模板
    const link = document.createElement('a');
    const blob = new Blob([res], { type: 'application/vnd.ms-excel' });
    const url = window.URL || window.webkitURL || window.moxURL;
    link.href = url.createObjectURL(blob);
    link.download = name + '.xlsx';
    link.click();
    window.URL.revokeObjectURL(url);
  }
  //获取用户浏览器信息
  getWindowNavigator() {
    let ratio = 0;
    if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
      //获取浏览器窗口外部的宽度,可视区域的宽度
      ratio = window.outerWidth / window.innerWidth;
    }
    if (ratio) {
      ratio = Math.round(ratio * 100);
    }
    const navigator = window.navigator; //浏览器navigator对象
    const navigatorObject = {
      appName: navigator.appName, //浏览器的官方名称
      appVersion: navigator.appVersion, //浏览器的平台和版本信息
      platform: navigator.platform, //浏览器运行的操作系统平台
      userAgent: navigator.userAgent, //浏览器的厂商和版本信息，即浏览器运行的操作系统、浏览器的版本、名称
      screenWidth: window.screen.width, //浏览器分辨率宽
      screenHeight: window.screen.height, //浏览器分辨率高
      zoomRatio: ratio
    };
    return navigatorObject;
  }

  //markdown转文本
  stripMarkdown(text) {
    // 匹配Markdown标题标签
    text = text.replace(/#+\s/g, '');
    // 匹配Markdown加粗标签
    text = text.replace(/\*\*(.*?)\*\*/g, '$1');
    // 匹配Markdown斜体标签
    text = text.replace(/\*(.*?)\*/g, '$1');
    // 匹配Markdown图片标签
    text = text.replace(/!\[(.*?)\]\((.*?)\)/g, '');
    // 匹配Markdown链接标签
    text = text.replace(/\[(.*?)\]\((.*?)\)/g, '$1 ($2)');
    // 匹配Markdown代码块标签
    text = text.replace(/```(.*?)\n(.*?)```/gs, '$2');
    // 匹配Markdown内联代码标签
    text = text.replace(/`([^`]+)`/g, '$1');
    // 返回纯文本
    return text.trim();
  }

  //通过子ID获取父级及以上的ID，直到最顶级
  getTreeDeepArr(key, treeData, idKey, idLabel, childKey) {
    // console.log(key, treeData, idKey, idLabel, childKey);
    idKey = idKey || 'value';
    idLabel = idLabel || 'label';
    childKey = childKey || 'children';
    // console.log(key, treeData, idKey, childKey);
    const arr = []; // 在递归时操作的数组
    const arrLabel = []; // 在递归时操作的数组
    let returnArr = []; // 存放结果的数组
    let depth = 0; // 定义全局层级
    // 定义递归函数
    function childrenEach(childrenData, depthN) {
      for (var j = 0; j < childrenData.length; j++) {
        depth = depthN; // 将执行的层级赋值 到 全局层级
        arr[depthN] = childrenData[j][idKey];
        arrLabel[depthN] = childrenData[j][idLabel];
        if (childrenData[j][idKey] == key) {
          returnArr = {
            iVal: arr.slice(0, depthN + 1),
            iLabel: arrLabel.slice(0, depthN + 1)
            // jobGroup: childrenData[j][childKey]
          };
          //将目前匹配的数组，截断并保存到结果数组，
          break;
        } else {
          if (childrenData[j][childKey]) {
            depth++;
            childrenEach(childrenData[j][childKey], depth);
          }
        }
      }
      return returnArr;
    }
    return childrenEach(treeData, depth);
  }
  setPrice(price, fieldExt) {
    if (fieldExt && this.isJSON(fieldExt)) {
      const num = JSON.parse(fieldExt)?.numberFormat;
      // num必须是数字类型
      if (!price && isNaN(price)) return price;
      const number = num === undefined ? 2 : num === 0 ? 0 : num;
      return parseFloat(parseFloat(price * 10000).toFixed(number));
    } else {
      // num必须是数字类型
      if (!price && isNaN(price)) return price;
      const number = fieldExt === undefined ? 2 : fieldExt === 0 ? 0 : fieldExt;
      return parseFloat(parseFloat(price * 10000).toFixed(number));
    }
  }
  getPrice(price, fieldExt) {
    if (fieldExt && this.isJSON(fieldExt)) {
      const num = JSON.parse(fieldExt)?.numberFormat;
      if (!price && isNaN(price)) return price;
      const number = num === undefined || num === '' || num === null ? 2 : num === 0 ? 0 : num;
      return parseFloat(parseFloat(price / 10000).toFixed(number));
    } else {
      if (!price && isNaN(price)) return price;
      const number = fieldExt === undefined || fieldExt === '' || fieldExt === null ? 2 : fieldExt === 0 ? 0 : fieldExt;
      return parseFloat(parseFloat(price / 10000).toFixed(number));
    }
  }

  /*********************************编辑处格式化展示*****************************************/
  // 省略0后小数点后有几位
  getZeros(num, fieldExt) {
    // 如果 num 无效，直接返回 num
    if (!num || isNaN(num)) return num;
    let numberFormat, isZero;
    // 解析 fieldExt
    if (fieldExt && this.isJSON(fieldExt)) {
      const parsedFieldExt = JSON.parse(fieldExt);
      numberFormat = parsedFieldExt?.numberFormat || parsedFieldExt?.dataType;
      isZero = parsedFieldExt?.isZero;
    } else if (typeof fieldExt === 'object' && fieldExt !== null) {
      numberFormat = fieldExt?.numberFormat || fieldExt?.dataType;
      isZero = fieldExt?.isZero;
    } else {
      return Number(fieldExt);
    }
    // 如果 isZero 为 true，处理小数部分
    if (isZero === true) {
      let numStr = num.toString();
      // 检查是否有小数点 去掉末尾的零
      if (numStr.includes('.')) {
        numStr = numStr.replace(/0+$/, '');
        // 如果去掉零后以小数点结尾，去掉小数点
        if (numStr.endsWith('.')) {
          numStr = numStr.slice(0, -1);
        }
        // 计算小数点后的位数
        const decimalIndex = numStr.indexOf('.');
        const decimalPlaces = numStr.length - decimalIndex - 1;
        return Math.min(decimalPlaces, numberFormat);
      } else {
        return 0;
      }
    } else {
      return Number(numberFormat);
    }
  }

  // 去除末尾的0
  removeTrailingZeros(input) {
    if (!input || isNaN(input)) return input;
    // 判断输入是否为字符串
    if (typeof input === 'string') {
      // 检查是否包含千分位
      const hasThousandSeparator = input.includes(',');
      // 去掉千分位，方便处理
      let numberStr = input.replace(/,/g, '');
      // 去掉末尾的零
      numberStr = numberStr.replace(/\.?0+$/, '');
      // 如果原始输入有千分位，格式化回千分位
      if (hasThousandSeparator) {
        // 将字符串转换为数字
        const number = parseFloat(numberStr);
        // 使用 toLocaleString 添加千分位
        return number.toLocaleString();
      }
      return numberStr;
    } else if (typeof input === 'number') {
      return input.toString().replace(/\.?0+$/, '');
    } else {
      return input;
    }
  }
  // 千分位
  formatterThousand(value) {
    const values = value.split('.');
    values[0] = values[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return values.join('.');
  }
  //是否显示千分符
  isShowThousandFormatter(value, fieldExt, fieldType) {
    if (!value || isNaN(value)) return value;
    if (fieldExt && this.isJSON(fieldExt)) {
      // 千分位
      if (JSON.parse(fieldExt)?.isPermillage !== undefined) {
        if (JSON.parse(fieldExt)?.isPermillage === true) {
          return this.formatterThousand(value.toString());
        } else {
          return value;
        }
      }
    }
    if (typeof fieldExt === 'object' && fieldExt !== null) {
      // 千分位
      if (fieldExt?.isPermillage !== undefined) {
        if (fieldExt?.isPermillage === true) {
          return this.formatterThousand(value.toString());
        } else {
          return value;
        }
      }
    }
    if (fieldType == 16 || (fieldType == 24 && [6, 16]?.includes(JSON.parse(fieldExt)?.type))) {
      return this.formatterThousand(value.toString());
    }
    return value;
  }
  // 数字
  getNumberShow(value, fieldExt) {
    // 检查 fieldValue 是否可以转换为有效的数字
    if (!isNaN(parseFloat(value)) && fieldExt && this.isJSON(fieldExt)) {
      const numberFormat = JSON.parse(fieldExt)?.numberFormat !== 100 ? JSON.parse(fieldExt)?.numberFormat || JSON.parse(fieldExt)?.dataType : 3;
      value = parseFloat(value).toFixed(numberFormat);
      // 末尾省略0
      if (JSON.parse(fieldExt)?.isZero === true) {
        value = this.removeTrailingZeros(value);
      }
      // 千分位
      if (JSON.parse(fieldExt)?.isPermillage === true) {
        value = this.formatterThousand(value.toString());
      }
      return value;
    }
    // 如果 fieldValue 不能转换为有效的数字，则返回空字符串
    return value;
  }
  // 判断是否是数字
  isNumberOrStringNumber(value) {
    return (typeof value === 'number' && !isNaN(value) && isFinite(value)) || (typeof value === 'string' && !isNaN(parseFloat(value)) && isFinite(parseFloat(value)));
  }

  /*********************************编辑处格式化展示*****************************************/
  // 金额
  getPriceShow(price, fieldExt) {
    if (fieldExt && this.isJSON(fieldExt)) {
      // 保留几位小数
      const num = JSON.parse(fieldExt)?.numberFormat || JSON.parse(fieldExt)?.dataType;
      if (!price || isNaN(price)) return price;
      const number = num === undefined || num === '' || num === null ? 2 : num === 0 ? 0 : num;
      const divideNumber = price / 10000;
      let formatedNumber = divideNumber.toFixed(number);
      // 末尾省略0
      if (JSON.parse(fieldExt)?.isZero === true) {
        formatedNumber = parseFloat(formatedNumber);
      }
      // 千分位处理
      if (JSON.parse(fieldExt)?.isPermillage === true) {
        formatedNumber = this.formatterThousand(formatedNumber.toString());
      }
      return formatedNumber;
    } else {
      if (!price || isNaN(price)) return price;
      const rawNumber = fieldExt === undefined || fieldExt === '' || fieldExt === null ? 2 : fieldExt === 0 ? 0 : Number(fieldExt);
      const number = isNaN(rawNumber) || rawNumber < 0 || rawNumber > 20 ? 2 : Math.floor(rawNumber);
      const divideNumber = price / 10000;
      const formatedNumber = parseFloat(divideNumber.toFixed(number));
      let formattedString = formatedNumber.toLocaleString('en-US', {
        maximumFractionDigits: number,
        minimumFractionDigits: number
      });
      formattedString = this.formatterThousand(formattedString);
      return formattedString;
    }
  }

  getPriceSetting(price) {
    const prices = ['万', '亿'];
    let num = parseFloat(price);
    for (let i = 0; i < prices.length; i++) {
      if (num >= 10000) {
        num /= 10000;
        price = num.toFixed(1) + prices[i];
      } else if (num >= 1000000 && i < prices.length - 1) {
        num /= 1000000;
        price = num.toFixed(1) + prices[i + 1];
      } else {
        break;
      }
    }
    return price;
  }

  /**
   * @brief 格式化金额 不*10000也不/10000，用于表单提交但是未调用接口时格式化展示，目前场景是关联对象表格新建展示
   * @param price
   * @param fieldExt
   * @return {string|any}
   */
  formatPriceShow(price, fieldExt) {
    if (fieldExt && this.isJSON(fieldExt)) {
      // 保留几位小数
      const num = JSON.parse(fieldExt)?.numberFormat || JSON.parse(fieldExt)?.dataType;
      if (!price || isNaN(price)) return price;
      const number = num === undefined || num === '' || num === null ? 2 : num === 0 ? 0 : num;
      let formatedNumber = parseFloat(price).toFixed(number);
      // 末尾省略0
      if (JSON.parse(fieldExt)?.isZero === true) {
        formatedNumber = parseFloat(formatedNumber);
      }
      // 千分位处理
      if (JSON.parse(fieldExt)?.isPermillage === true) {
        formatedNumber = this.formatterThousand(formatedNumber.toString());
      }
      return formatedNumber;
    } else {
      if (!price || isNaN(price)) return price;
      const rawNumber = fieldExt === undefined || fieldExt === '' || fieldExt === null ? 2 : fieldExt === 0 ? 0 : Number(fieldExt);
      const number = isNaN(rawNumber) || rawNumber < 0 || rawNumber > 20 ? 2 : Math.floor(rawNumber);
      const formatedNumber = parseFloat(parseFloat(price).toFixed(number));
      let formattedString = formatedNumber.toLocaleString('en-US', {
        maximumFractionDigits: number,
        minimumFractionDigits: number
      });
      formattedString = this.formatterThousand(formattedString);
      return formattedString;
    }
  }

  /**
   * @brief 格式化百分比 不*100，用于表单提交但是未调用接口时格式化展示，目前场景是关联对象表格新建展示
   * @param value
   * @param fieldExt
   * @return {string|number|*}
   */
  formatPercentageShow(value, fieldExt) {
    if (!value || isNaN(value)) return value;
    if (!isNaN(parseFloat(value)) && fieldExt && this.isJSON(fieldExt)) {
      const objectExt = JSON.parse(fieldExt);
      const numberFormat = objectExt?.numberFormat !== 100 ? objectExt?.numberFormat || objectExt?.dataType : 3;
      const num = Number(value);
      // 如果 num 不是有效的数字，则返回 NaN
      if (isNaN(num)) {
        return NaN;
      }
      const decimals = numberFormat === undefined || numberFormat === null || numberFormat === '' ? 4 : numberFormat === 0 ? 2 : Number(numberFormat);
      let result = num.toFixed(decimals);
      // 末尾省略0
      if (JSON.parse(fieldExt)?.isZero === true) {
        result = this.removeTrailingZeros(result);
      }
      // 将结果转换为数字类型并返回
      return result;
    } else {
      const num = Number(value);
      // 如果 num 不是有效的数字，则返回 NaN
      if (isNaN(num)) {
        return NaN;
      }
      const decimals = fieldExt === undefined || fieldExt === null || fieldExt === '' ? 4 : fieldExt === 0 ? 2 : Number(fieldExt);
      const result = num.toFixed(decimals);
      // 将结果转换为数字类型并返回
      return Number(result);
    }
  }
  // 检查是否是标准的JSON字符串
  isJSON(str) {
    if (typeof str === 'string' && str) {
      try {
        const obj = JSON.parse(str);
        return !!(typeof obj === 'object' && obj);
      } catch (e) {
        return false;
      }
    }
    return false;
  }
  // 安全解析json 字符串
  safeParseJson(str) {
    let success = false;
    let result = null;
    if (typeof str === 'string' && str) {
      try {
        const obj = JSON.parse(str);
        if (typeof obj === 'object' && obj) {
          success = true;
          result = obj;
        }
      } catch {
        /* empty */
      }
    }
    return {
      success,
      result
    };
  }
  // 设置百分比
  setPercentage(value, fieldExt) {
    if (fieldExt && this.isJSON(fieldExt)) {
      const numberFormat = JSON.parse(fieldExt)?.numberFormat;
      const num = Number(value);
      // 如果 num 不是有效的数字，则返回 NaN
      if (isNaN(num)) {
        return NaN;
      }
      const decimals = numberFormat === undefined || numberFormat === null || numberFormat === '' ? 4 : numberFormat === 0 ? 2 : Number(numberFormat) + 2;
      // 除以 100 并保留指定位数的小数
      const result = (num / 100).toFixed(decimals);
      //   console.log('setPercentage-result-1', result);
      // 将结果转换为数字类型并返回
      return Number(result);
    } else {
      const num = Number(value);
      // 如果 num 不是有效的数字，则返回 NaN
      if (isNaN(num)) {
        return NaN;
      }
      const decimals = fieldExt === undefined || fieldExt === null || fieldExt === '' ? 4 : fieldExt === 0 ? 2 : Number(fieldExt) + 2;
      // 除以 100 并保留指定位数的小数
      const result = (num / 100).toFixed(decimals);
      //   console.log('setPercentage-result-2', result);
      // 将结果转换为数字类型并返回
      return Number(result);
    }
  }
  // 获取百分比
  getPercentage(value, fieldExt) {
    if (!value || isNaN(value)) return value;
    if (!isNaN(parseFloat(value)) && fieldExt && this.isJSON(fieldExt)) {
      const numberFormat = JSON.parse(fieldExt)?.numberFormat !== 100 ? JSON.parse(fieldExt)?.numberFormat || JSON.parse(fieldExt)?.dataType : 3;
      const num = Number(value);
      // 如果 num 不是有效的数字，则返回 NaN
      if (isNaN(num)) {
        return NaN;
      }
      const decimals = numberFormat === undefined || numberFormat === null || numberFormat === '' ? 4 : numberFormat === 0 ? 2 : Number(numberFormat);
      let result = (num * 100).toFixed(decimals);
      // 末尾省略0
      if (JSON.parse(fieldExt)?.isZero === true) {
        result = this.removeTrailingZeros(result);
      }
      // 将结果转换为数字类型并返回
      return result;
    } else {
      const num = Number(value);
      // 如果 num 不是有效的数字，则返回 NaN
      if (isNaN(num)) {
        return NaN;
      }
      const decimals = fieldExt === undefined || fieldExt === null || fieldExt === '' ? 4 : fieldExt === 0 ? 2 : Number(fieldExt);
      const result = (num * 100).toFixed(decimals);
      // 将结果转换为数字类型并返回
      return Number(result);
    }
  }
  /**
   * @brief 字符串如果有非汉字字符出现，将两个非汉字看做一个汉字长度返回，最终返回字符创的总长度（非汉字字符为奇数时看做一个汉字长度）
   * @param {String} 字符串
   * @return {Number} 返回字符串长度
   */
  // 如果表头中有字母，把两个字母看作一个汉字的宽度计算
  getStrLen(str) {
    //兼容null和undefined报错问题
    if (!str) return 0;
    var realLength = 0,
      charCode = -1;
    for (var i = 0; i < str?.length; i++) {
      charCode = str?.charCodeAt(i);
      if (charCode >= 0 && charCode <= 128) {
        //匹配字母、数字
        realLength += 0.4;
      } else {
        //匹配汉字
        realLength += 1;
      }
    }
    return Math.ceil(realLength);
  }

  /**
   * @brief 获取指定对象中按钮的icon
   * @param {Object} 菜单权限
   * @param {Int} 对象entity
   * @return {Object} icons
   */
  getIconsByEntity(menus, entity) {
    const _icons = {};
    menus.map((mv) => {
      if (mv?.entity == entity && mv?.children && mv?.children?.length > 0) {
        mv.children?.map((mvv) => {
          _icons[mvv.code] = mvv.icon || '';
        });
      }
    });

    return _icons;
  }
  /**
   * @brief 获取指定对象中按钮的文案
   * @param {Object} 菜单权限
   * @param {Int} 对象entity
   * @return {Object} texts
   */
  getOptTextsByEntity(menus, entity) {
    const _texts = {};
    menus.map((mv) => {
      if (mv?.entity == entity && mv?.children && mv?.children?.length > 0) {
        mv.children?.map((mvv) => {
          _texts[mvv.code] = mvv.title || '';
        });
      }
    });

    return _texts;
  }
  /**
   * @brief 获取指定对象中新增/编辑按钮的文案
   * @param {Object} 菜单权限
   * @param {Int} 对象entity
   * @return {Object} texts
   */
  getUpdateOptTextsByEntity(menus) {
    const _texts = {};
    menus?.map((el) => {
      _texts[el.value] = { ...el?.setting };
    });

    return _texts;
  }
  /**
   * @brief 获取所有按钮的文案
   * @param {Object} 菜单权限
   * @return {Object} texts
   */
  getAllOptText(menus) {
    const _texts = {};
    menus.map((mv) => {
      if (mv?.children && mv?.children?.length > 0) {
        mv.children?.map((mvv) => {
          _texts[mvv.code] = mvv.title || '';
        });
      }
    });

    return _texts;
  }

  /**
   * @brief 获取指定对象中按钮的显示类型
   * @param {Object} 菜单权限
   * @param {Int} 对象entity
   * @return {Object} shows
   */
  getShowTypeByEntity(menus, entity) {
    const _show = {};
    menus.map((mv) => {
      if (mv?.entity == entity && mv?.children && mv?.children?.length > 0) {
        mv.children?.map((mvv) => {
          _show[mvv.code] = mvv.showType || '';
        });
      }
    });

    return _show;
  }
  /**
   * 防抖
   * @param {Function} func 执行函数
   * @param {Int} wait 延迟时间
   * @param {Boolean} immediate 是否立即执行
   */
  debounceFn(func, wait, immediate = true) {
    let timer;
    return function (...args) {
      const context = this;
      const later = function () {
        timer = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timer;
      clearTimeout(timer);
      timer = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }
  /**
   * 节流函数
   * @param {Function} fn 执行函数
   * @param {Int} delay 延迟时间
   */
  throttle(fn, delay) {
    let lastCall = 0;
    return function (...args) {
      const now = Date.now();
      if (now - lastCall >= delay) {
        lastCall = now;
        return fn.apply(this, args);
      }
    };
  }
  // 手机号码正则表达式，这里假设中国大陆的 11 位手机号码规则
  validatePhoneNumber(phoneNumber) {
    const phoneRegex = /^1[3-9]\d{9}$/;
    return phoneRegex.test(phoneNumber);
  }

  handleRichText(richText) {
    const richtext = richText;
    // console.log('isDetail', isDetail);
    const parser = new DOMParser();
    const doc = parser.parseFromString(richtext, 'text/html');
    let processedHTML;

    // 获取所有图片
    const images = Array.from(doc.querySelectorAll('img')).map((img) => img.getAttribute('src')?.split('/').pop() || '图片');

    // 获取所有文本节点
    const textContent = doc.body.textContent?.trim() || '';

    // 判断显示内容
    if (textContent) {
      // 如果有文字内容，显示文字
      processedHTML = textContent;
    } else if (images.length > 0) {
      // 如果没有文本内容但有图片，替换图片为图片名称
      processedHTML = images.join(', ');
    } else {
      // 如果既没有文字也没有图片
      processedHTML = '-';
    }

    // 获取处理后的HTML
    return processedHTML;
  }

  // 去除秒 日期字符串   "2024-10-11 19:07:54"  返回   "2024-10-11 19:07"
  removeSeconds(dateTimeString) {
    // 将字符串按空格拆分为日期和时间两部分
    const [date, time] = dateTimeString.split(' ');
    // 将时间按冒号拆分为小时、分钟、秒
    const [hours, minutes] = time.split(':').slice(0, 2);
    // 返回去除秒后的日期和时间字符串
    return `${date} ${hours}:${minutes}`;
  }
  //  时间转天数 36747 0天10小时12分
  convertSecondsToTimeFormat(seconds) {
    const days = Math.floor(seconds / (24 * 3600)); // 计算天数
    const hours = Math.floor((seconds % (24 * 3600)) / 3600); // 计算剩余的小时数
    const minutes = Math.floor((seconds % 3600) / 60); // 计算剩余的分钟数
    let result = '';
    if (days > 0) result += `${days}天`;
    if (hours > 0) result += `${hours}小时`;
    if (minutes > 0) result += `${minutes}分钟`;
    return result || '1分钟'; // 如果时间不足一分钟，返回"0分"
  }
  // 获取进行中时间
  getExecTime(dateStr) {
    if (!dateStr) return;
    const now = new Date();
    const inputDate = new Date(dateStr);
    const timeDiff = now.getTime() - inputDate.getTime();

    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));

    let result = '';
    if (days > 0) {
      result += `${days}天`;
    }
    if (hours > 0) {
      result += `${hours}小时`;
    }
    if (minutes > 0) {
      result += `${minutes}分钟`;
    }

    return result || '1分钟';
  }

  // 日期范围是否有值
  hasDateRange(dateRange) {
    return Array.isArray(dateRange) && dateRange.length;
  }
  // 是否展示日期范围值
  showDateRange(dateRange) {
    const hasRangeValue = tools.isJSON(dateRange) && JSON.parse(dateRange)?.beginDate && JSON.parse(dateRange)?.endDate;
    return hasRangeValue;
  }
  // 秒 转换为 小时 分钟 秒
  getDuration(second, day = false) {
    let duration = 0;
    if (day) {
      const days = Math.floor(second / 86400);
      const hours = Math.floor((second % 86400) / 3600);
      const minutes = Math.floor(((second % 86400) % 3600) / 60);
      const seconds = Math.floor(((second % 86400) % 3600) % 60);
      // var duration = days + "天" + hours + "小时" + minutes + "分" + seconds + "秒";
      duration = `${days ? days + '天' : ''}${hours ? hours + '小时' : ''}${minutes ? minutes + '分' : ''}${seconds ? seconds + '秒' : ''}`;
    } else {
      const hours = Math.floor(second / 3600);
      const minutes = Math.floor((second % 3600) / 60);
      duration = `${hours ? hours + '小时' : ''}${minutes ? minutes + '分' : ''}`;
    }
    if (second < 60) duration = `${second}秒`;
    return duration || 0;
  }
  //超链接（11）只能以http|https开头 并且不能包含汉字
  checkLink(link) {
    const regex = /^(http|https):\/\/[^\u4e00-\u9fa5]*$/;
    // 测试用例
    // const testUrls = ['https://', 'http://', 'https://www.example.com', 'http://www.示例.com'];
    // testUrls.forEach((url) => {
    //   console.log(`${url}: ${regex.test(url)}`);
    // });
    const trimmedUrl = link.trim();
    return regex.test(trimmedUrl);
  }
  // 兼容浏览器没有 requestIdleCallback 方法时，使用 setTimeout 替代
  requestIdleTask(callback, timeout) {
    if (typeof window.requestIdleCallback === 'function') {
      const options = timeout ? { timeout } : undefined;
      return window.requestIdleCallback(callback, options);
    } else {
      // Fallback 到 setTimeout，0ms 延迟模拟空闲行为
      return setTimeout(callback, 0);
    }
  }
  cancelIdleTask = (id) => {
    if (typeof window.cancelIdleCallback === 'function') {
      window.cancelIdleCallback(id);
    } else {
      clearTimeout(id);
    }
  };

  /**
   * 格式化汇总结果
   * @param fieldType 字段类型
   * @param fieldExt 字段扩展
   * @param value 值
   * @returns {*|string}
   */
  formatSummary(fieldType, fieldExt, value) {
    const amount = () => this.getPriceShow(value, fieldExt);
    const number = () => {
      const num = this.getNumberShow(value, fieldExt);
      const unit = this.isJSON(fieldExt) ? JSON.parse(fieldExt)?.numberUnit : '';
      return unit ? String(num + ' ' + unit) : String(num);
    };
    switch (fieldType) {
      // 金额
      case 16: {
        return amount();
      }
      // 数字
      case 7: {
        return number();
      }
      // 计算属性
      case 24: {
        if (typeof fieldExt !== 'string') {
          return value;
        }
        try {
          const { type } = JSON.parse(fieldExt) || {};
          switch (type) {
            case 6:
            case 16: {
              return amount();
            }
            case 5:
            case 7: {
              return number();
            }
            default: {
              return value;
            }
          }
        } catch {
          return value;
        }
      }
      default: {
        return value;
      }
    }
  }

  //存储localStorage
  setLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }
  //获取localStorage
  getLocalStorage(key) {
    return JSON.parse(localStorage.getItem(key));
  }
  //删除localStorage
  removeLocalStorage(key) {
    localStorage.removeItem(key);
  }

  // 存储sessionStorage
  setSessionStorage(value, key) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }
  //获取sessionStorage
  getSessionStorage(key) {
    return JSON.parse(sessionStorage.getItem(key));
  }
  //删除sessionStorage
  removeSessionStorage(key) {
    sessionStorage.removeItem(key);
  }

  isNumberLike(str) {
    return /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i.test(str);
  }
}

export const tools = new Tools();
